import React, { useState } from 'react';

const ReadMoreReadLess = ({ children, maxCharacterCount = 75 }) => {
    const text = children;
    const [isTruncated, setIsTruncated] = useState(true);

    const resultString = isTruncated ? text.slice(0, maxCharacterCount) : text;

    function toggleIsTruncated() {
        setIsTruncated(!isTruncated);
    }

    return (
        <div>
            {resultString}
            <span onClick={toggleIsTruncated} style={{ color: '#444', cursor: 'pointer', fontWeight: '500' }}>
                {isTruncated ? '... read more' : ' read less'}
            </span>
        </div>
    );
};

export default ReadMoreReadLess;
